import { redirect, error } from "@sveltejs/kit";
import { type } from "arktype";
import { eq } from "drizzle-orm";
import { s as stripe } from "../../../chunks/index4.js";
import { d as db, f as payment, u as userCard } from "../../../chunks/index3.js";
const load = async (event) => {
  const sessionId = event.url.searchParams.get("sessionId");
  if (!sessionId) {
    redirect(303, "/dashboard");
  }
  const session = await stripe.checkout.sessions.retrieve(sessionId);
  const metadataSchema = type({
    userId: "string > 0",
    cardId: "string > 0"
  });
  const validation = metadataSchema(session.metadata);
  if (validation instanceof type.errors) {
    error(400, validation.summary);
  }
  const [paymentItem] = await db.insert(payment).values({
    stripeCheckoutId: session.id,
    userId: validation.userId,
    amount: session.amount_total ?? 0
  }).returning();
  await db.update(userCard).set({
    paymentId: paymentItem.id
  }).where(eq(userCard.id, validation.cardId));
  return paymentItem;
};
export {
  load
};
